import React from 'react';
import styled from '@emotion/styled';

import BaseDialogContent from '@material-ui/core/DialogContent';
import theme from '../../themes/default';

const DialogContent = styled(BaseDialogContent)`
  min-height: calc(100% - 154px);
  padding: ${theme.spacing.large} ${theme.spacing.xLarge} 0px
    ${theme.spacing.large};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.blackOpacity87};
  background-color: ${theme.color.white};
`;

export default React.memo(DialogContent);
